export default __webpack_public_path__ + "static/media/CDF64EFD-3656-496E-BC9A-9516835E0EED.30a47e78.jpg";